import * as angular from 'angular';

"use strict";
angular.module('ManagerCtrl', []);

export default 'ManagerCtrl'